import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/ui/Header';
import Footer from '../../../components/ui/Footer';
import Icon from '../../../components/AppIcon';
import ProfessionalRegistrationForm from './ProfessionalRegistrationForm';
import AuthPortalSwitcher from '../../../components/ui/AuthPortalSwitcher';

const ProRegister = () => {
  useEffect(() => {
    document.title = 'Real Estate Agent Registration | HireBroker';
  }, []);

  const benefits = [
    { icon: 'ShieldCheck', title: 'Trust badge', desc: 'Verified real estate agents rank higher with users' },
    { icon: 'ClipboardList', title: 'Notice board', desc: 'Respond to live property needs from seekers' },
    { icon: 'Users', title: 'Collaboration', desc: 'Work with agents, brokers, and advisors in one place' },
  ];

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />
      <main className="flex-1 pt-16">
        <div className="container mx-auto px-4 py-8 lg:py-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 max-w-6xl mx-auto">
            <div className="hidden lg:block space-y-8">
              <div>
                <p className="text-sm font-medium text-secondary mb-2">Real Estate Agents</p>
                <h1 className="text-3xl font-bold text-foreground mb-3">
                  Join HireBroker as an agent, broker, or advisor
                </h1>
                <p className="text-muted-foreground">
                  Build credibility with verification, respond to user needs, and grow your pipeline
                  on a trusted platform.
                </p>
              </div>
              <div className="space-y-4">
                {benefits.map((b) => (
                  <div
                    key={b.title}
                    className="flex gap-3 p-4 rounded-xl border border-border bg-card"
                  >
                    <div className="w-10 h-10 rounded-lg bg-secondary/15 flex items-center justify-center flex-shrink-0">
                      <Icon name={b.icon} size={20} className="text-secondary" />
                    </div>
                    <div>
                      <p className="font-semibold text-foreground">{b.title}</p>
                      <p className="text-sm text-muted-foreground">{b.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
              <p className="text-sm text-muted-foreground">
                Looking for a home instead?{' '}
                <Link to="/register" className="text-primary font-medium underline">
                  User registration
                </Link>
              </p>
            </div>

            <div className="space-y-4">
              <AuthPortalSwitcher mode="register" active="professional" />
              <div className="bg-card rounded-2xl shadow-lg border border-border p-6 lg:p-8">
                <div className="lg:hidden text-center mb-6">
                  <div className="w-14 h-14 bg-secondary rounded-xl flex items-center justify-center mx-auto mb-3">
                    <Icon name="Briefcase" size={28} color="white" />
                  </div>
                  <h1 className="text-2xl font-bold">Real Estate Agent signup</h1>
                  <p className="text-sm text-muted-foreground mt-1">
                    Agents · Brokers · Advisors
                  </p>
                </div>
                <div className="hidden lg:block text-center mb-6">
                  <h2 className="text-2xl font-bold text-foreground">Create Real Estate Agent account</h2>
                  <p className="text-muted-foreground text-sm mt-1">
                    You&apos;ll complete verification after signup
                  </p>
                </div>
                <ProfessionalRegistrationForm />
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ProRegister;
